module.exports = __webpack_public_path__ + "static/media/nu.355ea434.svg";